(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deal-benefits"] && !Shopify.designMode) return;
  try {
    
  function updateReviewControls(section) {
    var carousel = section.querySelector('[data-review-carousel]');
    var previous = section.querySelector('[data-review-carousel-previous]');
    var next = section.querySelector('[data-review-carousel-next]');
    if (!carousel || !previous || !next) {
      return;
    }

    var maximumScroll = carousel.scrollWidth - carousel.clientWidth;
    previous.disabled = carousel.scrollLeft <= 1;
    next.disabled = carousel.scrollLeft >= maximumScroll - 1;
  }

  function initialiseReviewCarousel(section) {
    var carousel = section.querySelector('[data-review-carousel]');
    if (!carousel || carousel.dataset.controlsInitialised === 'true') {
      return;
    }

    carousel.dataset.controlsInitialised = 'true';
    carousel.addEventListener('scroll', function() {
      updateReviewControls(section);
    }, { passive: true });
    updateReviewControls(section);
  }

  document.querySelectorAll('.munbyn-deal-benefits').forEach(initialiseReviewCarousel);

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.munbyn-deal-benefits');
    if (section) {
      initialiseReviewCarousel(section);
    }
  });

  document.addEventListener('click', function(event) {
    var control = event.target.closest('[data-review-carousel-previous], [data-review-carousel-next]');
    if (!control) {
      return;
    }

    var section = control.closest('.munbyn-deal-benefits');
    var carousel = section ? section.querySelector('[data-review-carousel]') : null;
    var card = carousel ? carousel.querySelector('.munbyn-splash-review') : null;
    if (!carousel || !card) {
      return;
    }

    var gap = parseFloat(window.getComputedStyle(carousel).columnGap) || 0;
    var direction = control.hasAttribute('data-review-carousel-previous') ? -1 : 1;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    carousel.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: reducedMotion ? 'auto' : 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-business-links"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initialiseBusinessLinksCarousel(root) {
      var carousel = root.matches && root.matches('[data-business-links-carousel]')
        ? root
        : root.querySelector('[data-business-links-carousel]');

      if (!carousel || carousel.dataset.carouselInitialised === 'true') {
        return;
      }

      var viewport = carousel.querySelector('[data-business-links-viewport]');
      var slides = carousel.querySelectorAll('.deal-business-links__slide');
      var previous = carousel.querySelector('[data-business-links-previous]');
      var next = carousel.querySelector('[data-business-links-next]');
      var dots = carousel.querySelectorAll('[data-business-links-dot]');

      if (!viewport || slides.length < 2 || !previous || !next) {
        return;
      }

      carousel.dataset.carouselInitialised = 'true';
      var activeIndex = 0;
      var scrollFrame;

      function updateControls(index) {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;

        dots.forEach(function(dot, dotIndex) {
          var isActive = dotIndex === activeIndex;
          dot.classList.toggle('deal-business-links__dot--active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function goTo(index) {
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        viewport.scrollTo({
          left: viewport.clientWidth * index,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
        updateControls(index);
      }

      previous.addEventListener('click', function() {
        goTo(activeIndex - 1);
      });

      next.addEventListener('click', function() {
        goTo(activeIndex + 1);
      });

      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          goTo(index);
        });
      });

      viewport.addEventListener('scroll', function() {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function() {
          var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
          updateControls(index);
        });
      }, { passive: true });

      window.addEventListener('resize', function() {
        goTo(activeIndex);
      });

      updateControls(0);
    }

    function initialiseAllBusinessLinksCarousels(root) {
      if (root.matches && root.matches('[data-business-links-carousel]')) {
        initialiseBusinessLinksCarousel(root);
      }
      root.querySelectorAll('[data-business-links-carousel]').forEach(initialiseBusinessLinksCarousel);
    }

    initialiseAllBusinessLinksCarousels(document);

    if (!window.munbynBusinessLinksCarouselEventsBound) {
      document.addEventListener('shopify:section:load', function(event) {
        initialiseAllBusinessLinksCarousels(event.target);
      });
      window.munbynBusinessLinksCarouselEventsBound = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-flash-sale"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function parseBeijingTime(value) {
      var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/);
      if (!match) {
        return NaN;
      }

      var endTime = Date.parse(match.slice(1).join('').replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1-$2-$3T$4:$5:$6+08:00'));
      if (Number.isNaN(endTime)) {
        return NaN;
      }

      var beijingDate = new Date(endTime + 8 * 60 * 60 * 1000);
      var values = [
        beijingDate.getUTCFullYear(),
        beijingDate.getUTCMonth() + 1,
        beijingDate.getUTCDate(),
        beijingDate.getUTCHours(),
        beijingDate.getUTCMinutes(),
        beijingDate.getUTCSeconds()
      ];

      for (var index = 0; index < values.length; index += 1) {
        if (values[index] !== Number(match[index + 1])) {
          return NaN;
        }
      }

      return endTime;
    }

    function setText(section, selector, value) {
      var element = section.querySelector(selector);
      if (element) {
        element.textContent = String(value).padStart(2, '0');
      }
    }

    function endSale(section) {
      var hideOnExpiry = section.getAttribute('data-hide-on-expiry') === 'true';
      var timer = section.querySelector('[data-flash-timer]');
      var activeLabel = section.querySelector('[data-flash-active-label]');
      var ended = section.querySelector('[data-flash-ended]');
      var endedText = section.getAttribute('data-ended-text') || 'Sale ended';

      section.setAttribute('data-sale-ended', 'true');
      if (hideOnExpiry) {
        section.hidden = true;
        return;
      }
      if (timer) {
        timer.hidden = true;
      }
      if (activeLabel) {
        activeLabel.hidden = true;
      }
      if (ended) {
        ended.hidden = false;
      }

      section.querySelectorAll('[data-flash-submit]').forEach(function(button) {
        button.disabled = true;
        button.textContent = endedText;
      });
    }

    function updateCountdown(section, endTime) {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        endSale(section);
        if (section.munbynFlashTimer) {
          window.clearInterval(section.munbynFlashTimer);
          section.munbynFlashTimer = null;
        }
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      setText(section, '[data-flash-days]', days);
      setText(section, '[data-flash-hours]', hours);
      setText(section, '[data-flash-minutes]', minutes);
      setText(section, '[data-flash-seconds]', seconds);
    }

    function initFlashSale(section) {
      if (section.munbynFlashTimer) {
        window.clearInterval(section.munbynFlashTimer);
      }

      if (Number(section.getAttribute('data-product-count')) <= 0) {
        section.hidden = true;
        return;
      }

      var endDate = section.getAttribute('data-end-date');
      var endTime = parseBeijingTime(endDate);
      if (!endDate || Number.isNaN(endTime)) {
        section.hidden = true;
        return;
      }

      section.hidden = false;
      section.removeAttribute('data-sale-ended');
      updateCountdown(section, endTime);
      if (!section.hasAttribute('data-sale-ended')) {
        section.munbynFlashTimer = window.setInterval(function() {
          updateCountdown(section, endTime);
        }, 1000);
      }
    }

    function copyCode(button) {
      var code = button.getAttribute('data-flash-copy-code');
      var label = button.querySelector('[data-flash-copy-label]');
      var copyLabel = button.getAttribute('data-copy-label') || 'Copy';
      var copiedLabel = button.getAttribute('data-copied-label') || 'Copied';
      if (!code || !label) {
        return;
      }

      var showCopied = function() {
        label.textContent = copiedLabel;
        window.setTimeout(function() {
          label.textContent = copyLabel;
        }, 1500);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function() {
          label.textContent = code;
        });
        return;
      }

      var input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        showCopied();
      } catch (error) {
        label.textContent = code;
      }
      document.body.removeChild(input);
    }

    function initAllFlashSales(root) {
      if (root.matches && root.matches('[data-munbyn-flash-sale]')) {
        initFlashSale(root);
      }
      root.querySelectorAll('[data-munbyn-flash-sale]').forEach(initFlashSale);
    }

    if (!window.munbynFlashSaleEventsBound) {
      document.addEventListener('click', function(event) {
        var button = event.target.closest('[data-flash-copy-code]');
        if (button) {
          copyCode(button);
        }
      });

      document.addEventListener('shopify:section:load', function(event) {
        initAllFlashSales(event.target);
      });

      window.munbynFlashSaleEventsBound = true;
    }

    initAllFlashSales(document);
    document.addEventListener('DOMContentLoaded', function() {
      initAllFlashSales(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-hero"] && !Shopify.designMode) return;
  try {
    
  function parseMunbynBeijingTime(value) {
    var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/);
    if (!match) {
      return NaN;
    }

    var isoValue = match[1] + '-' + match[2] + '-' + match[3] + 'T' + match[4] + ':' + match[5] + ':' + match[6] + '+08:00';
    var endTime = Date.parse(isoValue);
    if (Number.isNaN(endTime)) {
      return NaN;
    }

    var beijingDate = new Date(endTime + 8 * 60 * 60 * 1000);
    var values = [
      beijingDate.getUTCFullYear(),
      beijingDate.getUTCMonth() + 1,
      beijingDate.getUTCDate(),
      beijingDate.getUTCHours(),
      beijingDate.getUTCMinutes(),
      beijingDate.getUTCSeconds()
    ];

    for (var index = 0; index < values.length; index += 1) {
      if (values[index] !== Number(match[index + 1])) {
        return NaN;
      }
    }

    return endTime;
  }

  function initMunbynHeroCountdowns() {
    var timers = document.querySelectorAll('[data-hero-countdown]');
    timers.forEach(function(timer) {
      if (timer.dataset.countdownReady === 'true') {
        return;
      }

      var endValue = timer.getAttribute('data-countdown-end');
      var endTime = parseMunbynBeijingTime(endValue);
      if (!endValue || Number.isNaN(endTime)) {
        timer.hidden = true;
        return;
      }

      timer.dataset.countdownReady = 'true';
      var daysEl = timer.querySelector('[data-countdown-days]');
      var hoursEl = timer.querySelector('[data-countdown-hours]');
      var minutesEl = timer.querySelector('[data-countdown-minutes]');
      var secondsEl = timer.querySelector('[data-countdown-seconds]');
      var expiredEl = timer.querySelector('[data-countdown-expired]');
      var expiredText = timer.getAttribute('data-countdown-expired-text') || '';

      var pad = function(value) {
        return String(value).padStart(2, '0');
      };

      var interval;
      var render = function() {
        var distance = endTime - Date.now();
        if (distance <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          if (expiredEl && expiredText) {
            expiredEl.textContent = expiredText;
            expiredEl.hidden = false;
          }
          window.clearInterval(interval);
          return;
        }

        var totalSeconds = Math.floor(distance / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      };

      render();
      interval = window.setInterval(render, 1000);
    });
  }

  initMunbynHeroCountdowns();
  document.addEventListener('shopify:section:load', initMunbynHeroCountdowns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-kit-comparison"] && !Shopify.designMode) return;
  try {
    
  function refreshKitPreview(card) {
    var includesWrap = card.querySelector('[data-kit-includes-wrap]');
    var includes = card.querySelector('[data-kit-includes]');
    var fullButton = card.querySelector('[data-kit-view-full]');
    if (!includesWrap || !includes || !fullButton) {
      return;
    }

    window.requestAnimationFrame(function() {
      var isOverflowing = !includesWrap.hidden && includes.scrollHeight > includes.clientHeight + 1;
      fullButton.hidden = !isOverflowing;
    });
  }

  function refreshKitPreviews(root) {
    root.querySelectorAll('[data-kit-card]').forEach(refreshKitPreview);
  }

  function getKitVisibleLimit(section) {
    var desktopLimit = parseInt(section.getAttribute('data-kit-desktop-visible'), 10) || 3;
    var tabletLimit = parseInt(section.getAttribute('data-kit-tablet-visible'), 10) || 2;
    var mobileLimit = parseInt(section.getAttribute('data-kit-mobile-visible'), 10) || 4;

    if (window.matchMedia('(max-width: 620px)').matches) {
      return mobileLimit;
    }

    if (window.matchMedia('(max-width: 989px)').matches) {
      return tabletLimit;
    }

    return desktopLimit;
  }

  function refreshKitVisibility(section) {
    var cards = section.querySelectorAll('[data-kit-card]');
    var showMoreButton = section.querySelector('[data-kit-show-more]');
    var toggleWrap = section.querySelector('[data-kit-toggle-wrap]');
    var visibleLimit = getKitVisibleLimit(section);
    var isExpanded = showMoreButton && showMoreButton.getAttribute('aria-expanded') === 'true';

    cards.forEach(function(card, index) {
      card.hidden = !isExpanded && index >= visibleLimit;
    });

    if (toggleWrap) {
      toggleWrap.hidden = cards.length <= visibleLimit;
    }
  }

  function refreshKitVisibilities(root) {
    if (root.matches && root.matches('.munbyn-kit-comparison')) {
      refreshKitVisibility(root);
    }

    root.querySelectorAll('.munbyn-kit-comparison').forEach(refreshKitVisibility);
  }

  refreshKitVisibilities(document);
  refreshKitPreviews(document);

  document.addEventListener('shopify:section:load', function(event) {
    refreshKitVisibilities(event.target);
    refreshKitPreviews(event.target);
  });

  window.addEventListener('resize', function() {
    refreshKitVisibilities(document);
    refreshKitPreviews(document);
  });

  document.addEventListener('change', function(event) {
    var selector = event.target.closest('[data-kit-variant-selector]');
    if (!selector) {
      return;
    }

    var card = selector.closest('[data-kit-card]');
    var option = selector.options[selector.selectedIndex];
    if (!card || !option) {
      return;
    }

    var variantInput = card.querySelector('[data-kit-variant-input]');
    var addButton = card.querySelector('[data-kit-add-button]');
    var price = card.querySelector('[data-kit-price]');
    var installmentPrice = card.querySelector('[data-kit-installment-price]');
    var compareAt = card.querySelector('[data-kit-compare-at]');
    var image = card.querySelector('.munbyn-kit-card__image');
    var productLinks = card.querySelectorAll('[data-kit-product-link]');
    var includesWrap = card.querySelector('[data-kit-includes-wrap]');
    var includes = card.querySelector('[data-kit-includes]');
    var template = document.getElementById(option.getAttribute('data-kit-template'));
    var isAvailable = option.getAttribute('data-available') === 'true';
    var productUrl = option.getAttribute('data-product-url') || '';

    if (variantInput) {
      variantInput.value = option.value;
    }

    if (addButton) {
      addButton.disabled = !isAvailable;
      addButton.textContent = isAvailable ? card.getAttribute('data-add-label') || 'Add Kit' : 'Sold Out';
    }

    if (price) {
      price.innerHTML = option.getAttribute('data-price') || '';
    }

    if (installmentPrice) {
      installmentPrice.innerHTML = option.getAttribute('data-installment-price') || '';
    }

    if (compareAt) {
      var compareAtText = option.getAttribute('data-compare-at') || '';
      compareAt.innerHTML = compareAtText;
      compareAt.hidden = !compareAtText;
    }

    if (image) {
      var imageUrl = option.getAttribute('data-image') || '';
      if (imageUrl) {
        image.src = imageUrl;
        image.removeAttribute('srcset');
      }
    }

    productLinks.forEach(function(link) {
      if (productUrl) {
        link.href = productUrl;
      }
    });

    if (includes && includesWrap) {
      var hasContent = template && template.getAttribute('data-kit-has-content') === 'true';
      includes.innerHTML = hasContent ? template.innerHTML : '';
      includesWrap.hidden = !hasContent;
      refreshKitPreview(card);
    }
  });

  document.addEventListener('click', function(event) {
    var fullButton = event.target.closest('[data-kit-view-full]');
    var closeButton = event.target.closest('[data-kit-dialog-close]');
    var showMoreButton = event.target.closest('[data-kit-show-more]');

    if (showMoreButton) {
      var showMoreSection = showMoreButton.closest('.munbyn-kit-comparison');
      var showMoreLabel = showMoreButton.querySelector('[data-kit-show-more-text]');
      var isExpanded = showMoreButton.getAttribute('aria-expanded') === 'true';

      showMoreButton.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      if (showMoreLabel) {
        showMoreLabel.textContent = isExpanded ? 'Show more' : 'Show less';
      }

      if (showMoreSection) {
        refreshKitVisibility(showMoreSection);
        refreshKitPreviews(showMoreSection);
      }
      return;
    }

    if (fullButton) {
      var card = fullButton.closest('[data-kit-card]');
      var section = fullButton.closest('.munbyn-kit-comparison');
      var dialog = section ? section.querySelector('[data-kit-dialog]') : null;
      var dialogContent = dialog ? dialog.querySelector('[data-kit-dialog-content]') : null;
      var dialogContext = dialog ? dialog.querySelector('[data-kit-dialog-context]') : null;
      var includes = card ? card.querySelector('[data-kit-includes]') : null;
      var selector = card ? card.querySelector('[data-kit-variant-selector]') : null;
      if (!card || !dialog || !dialogContent || !includes) {
        return;
      }

      var context = card.getAttribute('data-kit-card-title') || '';
      if (selector && selector.options[selector.selectedIndex]) {
        context = context + ' - ' + selector.options[selector.selectedIndex].textContent.replace(' - Sold out', '').trim();
      }

      dialogContent.innerHTML = includes.innerHTML;
      if (dialogContext) {
        dialogContext.textContent = context;
      }
      dialog.showModal();
      return;
    }

    if (closeButton) {
      var closeDialog = closeButton.closest('[data-kit-dialog]');
      if (closeDialog) {
        closeDialog.close();
      }
      return;
    }

    var openDialog = event.target.matches('[data-kit-dialog]') ? event.target : null;
    if (openDialog) {
      openDialog.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-money-counter-reference"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-money-counter-landing]').forEach((root) => {
      if (root.dataset.moneyCounterReady === 'true') return;
      root.dataset.moneyCounterReady = 'true';

      const dataNode = root.querySelector('[data-money-counter-models]');
      if (!dataNode) return;

      const data = JSON.parse(dataNode.textContent);
      const models = data.models;
      const labels = data.labels;
      const rows = [
        [labels.price, 'price'],
        [labels.speed, 'speed'],
        [labels.mixed, 'mixed'],
        [labels.currencies, 'currencies'],
        [labels.detection, 'detection'],
        [labels.pockets, 'pockets'],
        [labels.features, 'features'],
        [labels.bestFor, 'bestFor']
      ];
      const preferredDefaults = ['imc20', 'imc22', 'imc40', 'imc23'];
      const availableIds = models.map((model) => model.id);
      const defaultSlots = preferredDefaults.every((id) => availableIds.includes(id))
        ? preferredDefaults
        : availableIds.slice(0, 4);
      const requestedSlots = Array.from(new Set(new URLSearchParams(window.location.search).get('compare')?.split(',') || []))
        .filter((id) => availableIds.includes(id))
        .slice(0, 4);
      let compareSlots = requestedSlots.length === 4 ? requestedSlots : [...defaultSlots];
      const filterAliases = { all: 'all', bill: 'bill', basic: 'bill', mixed: 'mixed', professional: 'professional', 'two-pocket': 'professional', coin: 'coin' };
      const requestedFilter = new URLSearchParams(window.location.search).get('type');
      let activeFilter = filterAliases[requestedFilter] || 'all';

      const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
      }[character]));

      const pushEvent = (eventName, detail = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, landing_page: 'money_counter_deals', ...detail });
      };

      const syncUrl = () => {
        const url = new URL(window.location.href);
        const isDefault = compareSlots.every((id, index) => id === defaultSlots[index]);
        if (isDefault) url.searchParams.delete('compare');
        else url.searchParams.set('compare', compareSlots.join(','));
        window.history.replaceState(null, '', url);
      };

      const optionsFor = (slot, activeSlots = compareSlots) => models.map((model) => {
        const isSelected = compareSlots[slot] === model.id;
        const isUsed = activeSlots.some((id, index) => index !== slot && id === model.id);
        return `<option value="${escapeHtml(model.id)}"${isSelected ? ' selected' : ''}${isUsed ? ' disabled' : ''}>${escapeHtml(model.model)}</option>`;
      }).join('');

      const imageFor = (model) => model.image
        ? `<img src="${escapeHtml(model.image)}" alt="${escapeHtml(model.title)}" width="160" height="120" loading="lazy">`
        : `<span aria-hidden="true">${escapeHtml(model.model)}</span>`;

      const namedColorHex = {
        black: '#111111',
        white: '#ffffff',
        gray: '#9ca3af',
        grey: '#9ca3af',
        silver: '#cbd5e1',
        blue: '#2563eb',
        red: '#dc2626',
        orange: '#f97316',
        green: '#16a34a',
        gold: '#d4a017'
      };

      const swatchesFor = (model) => {
        if (!Array.isArray(model.colors) || model.colors.length === 0) return '';
        const chips = model.colors.map((color) => {
          const hex = color.hex || namedColorHex[String(color.name || '').trim().toLowerCase()] || '';
          const dot = hex
            ? `<span class="money-counter-deals__color-dot" style="--mc-swatch: ${escapeHtml(hex)}" aria-hidden="true"></span>`
            : '';
          return `<span class="money-counter-deals__color-chip" title="${escapeHtml(color.name)}">${dot}<span>${escapeHtml(color.name)}</span></span>`;
        }).join('');
        return `<div class="money-counter-deals__color-swatches" aria-label="Available colors">${chips}</div>`;
      };

      const renderComparison = () => {
        const selected = compareSlots.map((id) => models.find((model) => model.id === id));
        const mobileSelected = selected.slice(0, 2);
        const mobileSlots = compareSlots.slice(0, 2);
        const isDefault = compareSlots.every((id, index) => id === defaultSlots[index]);
        root.querySelector('[data-compare-status]').textContent = isDefault ? labels.defaultStatus : labels.customStatus;
        root.querySelector('[data-reset-compare]').hidden = isDefault;

        root.querySelector('[data-desktop-compare]').innerHTML = `
          <thead><tr><th scope="col">${escapeHtml(labels.feature)}</th>${selected.map((model, slot) => `
            <th scope="col">
              <label for="deal-desktop-${slot}">${escapeHtml(labels.model)} ${slot + 1}</label>
              <div class="money-counter-deals__compare-head">
                <a class="money-counter-deals__compare-image" href="${escapeHtml(model.url)}" aria-label="${escapeHtml(labels.view)} ${escapeHtml(model.model)}">${imageFor(model)}</a>
                <select id="deal-desktop-${slot}" data-compare-slot="${slot}" aria-label="${escapeHtml(labels.model)} ${slot + 1}">${optionsFor(slot)}</select>
              </div>
              <div class="money-counter-deals__model-meta">
                <a class="money-counter-deals__model-link" href="${escapeHtml(model.url)}">${escapeHtml(model.model)}</a>
                ${swatchesFor(model)}
              </div>
            </th>`).join('')}</tr></thead>
          <tbody>${rows.map(([label, key]) => `<tr><th scope="row">${escapeHtml(label)}</th>${selected.map((model) => `<td>${escapeHtml(model[key])}</td>`).join('')}</tr>`).join('')}</tbody>`;

        root.querySelector('[data-mobile-compare-selectors]').innerHTML = `<div class="money-counter-deals__mobile-dimension-label"><span>Models</span><strong>Features</strong></div>` + mobileSelected.map((model, slot) => `
          <div class="money-counter-deals__mobile-selector">
            <a class="money-counter-deals__mobile-model-image" href="${escapeHtml(model.url)}" aria-label="${escapeHtml(labels.view)} ${escapeHtml(model.model)}">${imageFor(model)}</a>
            <label for="deal-mobile-${slot}">${escapeHtml(labels.model)} ${slot + 1}</label>
            <div class="money-counter-deals__mobile-selector-head">
              <select id="deal-mobile-${slot}" data-compare-slot="${slot}" aria-label="${escapeHtml(labels.model)} ${slot + 1}">${optionsFor(slot, mobileSlots)}</select>
            </div>
          </div>`).join('');

        root.querySelector('[data-mobile-compare-results]').innerHTML = rows.map(([label, key]) => `
          <div class="money-counter-deals__mobile-compare-row" role="row">
            <div class="money-counter-deals__mobile-feature" role="rowheader">${escapeHtml(label)}</div>
            ${mobileSelected.map((model) => `<div class="money-counter-deals__mobile-value" role="cell">${escapeHtml(model[key])}</div>`).join('')}
          </div>`).join('');
      };

      const syncFilterUrl = () => {
        const url = new URL(window.location.href);
        if (activeFilter === 'all') url.searchParams.delete('type');
        else url.searchParams.set('type', activeFilter);
        window.history.replaceState(null, '', url);
      };

      const renderProductFilter = () => {
        const cards = Array.from(root.querySelectorAll('[data-money-counter-product-card]'));
        let visibleCount = 0;
        cards.forEach((card) => {
          const visible = activeFilter === 'all' || card.dataset.moneyCounterCategory === activeFilter;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        root.querySelectorAll('[data-money-counter-filter]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.moneyCounterFilter === activeFilter));
        });
        root.querySelectorAll('[data-money-counter-scene]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.moneyCounterScene === activeFilter));
        });
        const status = root.querySelector('[data-money-counter-filter-status]');
        if (status) status.textContent = `${visibleCount} official models shown.`;
      };

      const initReviewCarousel = (attempts = 0) => {
        const slider = root.querySelector('[data-money-counter-review-carousel]');
        if (!slider) return;
        if (slider.splide) return;
        if (typeof window.Splide === 'undefined') {
          if (attempts < 100) window.setTimeout(() => initReviewCarousel(attempts + 1), 100);
          return;
        }

        const slideCount = slider.querySelectorAll('.splide__slide').length;
        if (!slideCount) return;
        const previous = root.querySelector('[data-review-prev]');
        const next = root.querySelector('[data-review-next]');
        const status = root.querySelector('[data-review-status]');
        const splide = new window.Splide(slider, {
          type: 'slide',
          rewind: true,
          perPage: 3,
          perMove: 3,
          gap: '16px',
          arrows: false,
          pagination: slideCount > 1,
          autoplay: false,
          drag: slideCount > 1,
          keyboard: 'focused',
          speed: 420,
          breakpoints: {
            990: { perPage: 2, perMove: 2 },
            700: { perPage: 1, perMove: 1 }
          },
          reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' }
        });

        const updateReviewStatus = () => {
          const visibleCount = Number(splide.options.perPage || 1);
          const movable = slideCount > visibleCount;
          if (previous) previous.hidden = !movable;
          if (next) next.hidden = !movable;
          if (status) status.textContent = `Review ${splide.index + 1} of ${slideCount}`;
        };
        if (previous) {
          previous.disabled = slideCount < 2;
          previous.addEventListener('click', () => splide.go('<'));
        }
        if (next) {
          next.disabled = slideCount < 2;
          next.addEventListener('click', () => splide.go('>'));
        }
        splide.on('mounted moved resized updated', updateReviewStatus);
        splide.mount();
        slider.splide = splide;
        updateReviewStatus();
      };

      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-compare-slot]');
        if (!select) return;
        const slot = Number(select.dataset.compareSlot);
        const isMobile = Boolean(select.closest('[data-mobile-compare-selectors]'));
        const previousId = compareSlots[slot];
        const duplicateIndex = compareSlots.findIndex((id, index) => index !== slot && id === select.value);
        if (duplicateIndex !== -1) {
          if (isMobile && duplicateIndex >= 2) {
            compareSlots[duplicateIndex] = previousId;
          } else {
            renderComparison();
            return;
          }
        }
        compareSlots[slot] = select.value;
        syncUrl();
        renderComparison();
        pushEvent('change_compare_model', { product: select.value, compare_slot: slot + 1 });
      });

      root.querySelector('[data-reset-compare]').addEventListener('click', () => {
        compareSlots = [...defaultSlots];
        syncUrl();
        renderComparison();
        pushEvent('reset_compare_models');
      });

      root.querySelectorAll('[data-money-counter-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.moneyCounterFilter;
          syncFilterUrl();
          renderProductFilter();
          pushEvent('filter_money_counter_models', { filter: activeFilter });
        });
      });

      root.querySelectorAll('[data-money-counter-scene]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.moneyCounterScene;
          syncFilterUrl();
          renderProductFilter();
          const catalog = root.querySelector('#money-counter-best-sellers');
          if (catalog) catalog.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });

      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-money-counter-event]');
        if (!trigger) return;
        const eventName = trigger.getAttribute('data-money-counter-event');
        if (eventName === 'add_to_cart') return;
        pushEvent(eventName, {
          product: trigger.getAttribute('data-money-counter-product') || undefined,
          use_case: trigger.getAttribute('data-money-counter-use-case') || undefined
        });
      });

      root.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-money-counter-event="add_to_cart"]');
        if (!form) return;
        pushEvent('add_to_cart', { product: form.getAttribute('data-money-counter-product') || undefined });
      });

      pushEvent('view_landing_page');
      renderComparison();
      renderProductFilter();
      initReviewCarousel();
      window.addEventListener('load', () => initReviewCarousel(), { once: true });
      const renderIcons = () => { if (window.lucide) window.lucide.createIcons(); };
      renderIcons();
      window.addEventListener('load', renderIcons, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-pda-reference"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-money-counter-landing]').forEach((root) => {
      if (root.dataset.moneyCounterReady === 'true') return;
      root.dataset.moneyCounterReady = 'true';

      const dataNode = root.querySelector('[data-money-counter-models]');
      if (!dataNode) return;

      const data = JSON.parse(dataNode.textContent);
      const models = data.models;
      const labels = data.labels;
      const rows = [
        [labels.price, 'price'],
        [labels.scanRange, 'scanRange'],
        [labels.scanEngine, 'scanEngine'],
        [labels.os, 'os'],
        [labels.connectivity, 'connectivity'],
        [labels.ruggedness, 'ruggedness'],
        [labels.battery, 'battery'],
        [labels.bestFor, 'bestFor']
      ];
      const preferredDefaults = ['mc005', 'ipda101', 'as01', 'ipda101p-lr'];
      const availableIds = models.map((model) => model.id);
      const defaultSlots = preferredDefaults.every((id) => availableIds.includes(id))
        ? preferredDefaults
        : availableIds.slice(0, 4);
      const requestedSlots = Array.from(new Set(new URLSearchParams(window.location.search).get('compare')?.split(',') || []))
        .filter((id) => availableIds.includes(id))
        .slice(0, 4);
      let compareSlots = requestedSlots.length === 4 ? requestedSlots : [...defaultSlots];
      const filterAliases = { all: 'all', standard: 'standard', 'long-range': 'long-range', keypad: 'keypad', rugged: 'keypad', touchscreen: 'touchscreen' };
      const requestedFilter = new URLSearchParams(window.location.search).get('type');
      let activeFilter = filterAliases[requestedFilter] || 'all';

      const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
      }[character]));

      const pushEvent = (eventName, detail = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, landing_page: 'pda_deals', ...detail });
      };

      const syncUrl = () => {
        const url = new URL(window.location.href);
        const isDefault = compareSlots.every((id, index) => id === defaultSlots[index]);
        if (isDefault) url.searchParams.delete('compare');
        else url.searchParams.set('compare', compareSlots.join(','));
        window.history.replaceState(null, '', url);
      };

      const optionsFor = (slot, activeSlots = compareSlots, compact = false) => models.map((model) => {
        const isSelected = compareSlots[slot] === model.id;
        const isUsed = activeSlots.some((id, index) => index !== slot && id === model.id);
        const optionLabel = compact ? model.mobileModel : model.model;
        return `<option value="${escapeHtml(model.id)}"${isSelected ? ' selected' : ''}${isUsed ? ' disabled' : ''}>${escapeHtml(optionLabel)}</option>`;
      }).join('');

      const imageFor = (model) => model.image
        ? `<img src="${escapeHtml(model.image)}" alt="${escapeHtml(model.title)}" width="160" height="120" loading="lazy">`
        : `<span aria-hidden="true">${escapeHtml(model.model)}</span>`;

      const namedColorHex = {
        black: '#111111',
        white: '#ffffff',
        gray: '#9ca3af',
        grey: '#9ca3af',
        silver: '#cbd5e1',
        blue: '#2563eb',
        red: '#dc2626',
        orange: '#f97316',
        green: '#16a34a',
        gold: '#d4a017'
      };

      const swatchesFor = (model) => {
        if (!Array.isArray(model.colors) || model.colors.length === 0) return '';
        const chips = model.colors.map((color) => {
          const hex = color.hex || namedColorHex[String(color.name || '').trim().toLowerCase()] || '';
          const dot = hex
            ? `<span class="money-counter-deals__color-dot" style="--mc-swatch: ${escapeHtml(hex)}" aria-hidden="true"></span>`
            : '';
          return `<span class="money-counter-deals__color-chip" title="${escapeHtml(color.name)}">${dot}<span>${escapeHtml(color.name)}</span></span>`;
        }).join('');
        return `<div class="money-counter-deals__color-swatches" aria-label="Available colors">${chips}</div>`;
      };

      const renderComparison = () => {
        const selected = compareSlots.map((id) => models.find((model) => model.id === id));
        const mobileSelected = selected.slice(0, 2);
        const mobileSlots = compareSlots.slice(0, 2);
        const isDefault = compareSlots.every((id, index) => id === defaultSlots[index]);
        root.querySelector('[data-compare-status]').textContent = isDefault ? labels.defaultStatus : labels.customStatus;
        root.querySelector('[data-reset-compare]').hidden = isDefault;

        root.querySelector('[data-desktop-compare]').innerHTML = `
          <thead><tr><th scope="col">${escapeHtml(labels.feature)}</th>${selected.map((model, slot) => `
            <th scope="col">
              <label for="deal-desktop-${slot}">${escapeHtml(labels.model)} ${slot + 1}</label>
              <div class="money-counter-deals__compare-head">
                <a class="money-counter-deals__compare-image" href="${escapeHtml(model.url)}" aria-label="${escapeHtml(labels.view)} ${escapeHtml(model.model)}">${imageFor(model)}</a>
                <select id="deal-desktop-${slot}" data-compare-slot="${slot}" aria-label="${escapeHtml(labels.model)} ${slot + 1}">${optionsFor(slot)}</select>
              </div>
              <div class="money-counter-deals__model-meta">
                <a class="money-counter-deals__model-link" href="${escapeHtml(model.url)}">${escapeHtml(model.model)}</a>
                ${swatchesFor(model)}
              </div>
            </th>`).join('')}</tr></thead>
          <tbody>${rows.map(([label, key]) => `<tr><th scope="row">${escapeHtml(label)}</th>${selected.map((model) => `<td>${escapeHtml(model[key])}</td>`).join('')}</tr>`).join('')}</tbody>`;

        root.querySelector('[data-mobile-compare-selectors]').innerHTML = `<div class="money-counter-deals__mobile-dimension-label"><span>Models</span><strong>Features</strong></div>` + mobileSelected.map((model, slot) => `
          <div class="money-counter-deals__mobile-selector">
            <a class="money-counter-deals__mobile-model-image" href="${escapeHtml(model.url)}" aria-label="${escapeHtml(labels.view)} ${escapeHtml(model.model)}">${imageFor(model)}</a>
            <label for="deal-mobile-${slot}">${escapeHtml(labels.model)} ${slot + 1}</label>
            <div class="money-counter-deals__mobile-selector-head">
              <select id="deal-mobile-${slot}" data-compare-slot="${slot}" aria-label="${escapeHtml(labels.model)} ${slot + 1}">${optionsFor(slot, mobileSlots, true)}</select>
            </div>
          </div>`).join('');

        root.querySelector('[data-mobile-compare-results]').innerHTML = rows.map(([label, key]) => `
          <div class="money-counter-deals__mobile-compare-row" role="row">
            <div class="money-counter-deals__mobile-feature" role="rowheader">${escapeHtml(label)}</div>
            ${mobileSelected.map((model) => `<div class="money-counter-deals__mobile-value" role="cell">${escapeHtml(model[key])}</div>`).join('')}
          </div>`).join('');
      };

      const syncFilterUrl = () => {
        const url = new URL(window.location.href);
        if (activeFilter === 'all') url.searchParams.delete('type');
        else url.searchParams.set('type', activeFilter);
        window.history.replaceState(null, '', url);
      };

      const renderProductFilter = () => {
        const cards = Array.from(root.querySelectorAll('[data-money-counter-product-card]'));
        let visibleCount = 0;
        cards.forEach((card) => {
          const categories = (card.dataset.moneyCounterCategory || '').split(/\s+/);
          const visible = activeFilter === 'all' || categories.includes(activeFilter);
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        root.querySelectorAll('[data-money-counter-filter]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.moneyCounterFilter === activeFilter));
        });
        root.querySelectorAll('[data-money-counter-scene]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.moneyCounterScene === activeFilter));
        });
        const status = root.querySelector('[data-money-counter-filter-status]');
        if (status) status.textContent = `${visibleCount} PDA families shown.`;
      };

      const initReviewCarousel = (attempts = 0) => {
        const slider = root.querySelector('[data-money-counter-review-carousel]');
        if (!slider) return;
        if (slider.splide) return;
        if (typeof window.Splide === 'undefined') {
          if (attempts < 100) window.setTimeout(() => initReviewCarousel(attempts + 1), 100);
          return;
        }

        const slideCount = slider.querySelectorAll('.splide__slide').length;
        if (!slideCount) return;
        const previous = root.querySelector('[data-review-prev]');
        const next = root.querySelector('[data-review-next]');
        const status = root.querySelector('[data-review-status]');
        const splide = new window.Splide(slider, {
          type: 'slide',
          rewind: true,
          perPage: 3,
          perMove: 3,
          gap: '16px',
          arrows: false,
          pagination: slideCount > 1,
          autoplay: false,
          drag: slideCount > 1,
          keyboard: 'focused',
          speed: 420,
          breakpoints: {
            990: { perPage: 2, perMove: 2 },
            700: { perPage: 1, perMove: 1 }
          },
          reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' }
        });

        const updateReviewStatus = () => {
          const visibleCount = Number(splide.options.perPage || 1);
          const movable = slideCount > visibleCount;
          if (previous) previous.hidden = !movable;
          if (next) next.hidden = !movable;
          if (status) status.textContent = `Review ${splide.index + 1} of ${slideCount}`;
        };
        if (previous) {
          previous.disabled = slideCount < 2;
          previous.addEventListener('click', () => splide.go('<'));
        }
        if (next) {
          next.disabled = slideCount < 2;
          next.addEventListener('click', () => splide.go('>'));
        }
        splide.on('mounted moved resized updated', updateReviewStatus);
        splide.mount();
        slider.splide = splide;
        updateReviewStatus();
      };

      root.addEventListener('change', (event) => {
        const variantSelect = event.target.closest('[data-product-variant-select]');
        if (variantSelect) {
          const card = variantSelect.closest('[data-money-counter-product-card]');
          const option = variantSelect.options[variantSelect.selectedIndex];
          const price = card?.querySelector('[data-card-price]');
          const comparePrice = card?.querySelector('[data-card-compare-price]');
          const discountBadge = card?.querySelector('[data-card-discount-badge]');
          const cardImage = card?.querySelector('[data-card-image]');
          const quantityInput = card?.querySelector('[data-quantity-input]');
          if (price && option?.dataset.price) price.textContent = option.dataset.price;
          if (comparePrice) {
            comparePrice.textContent = option?.dataset.comparePrice || '';
            comparePrice.hidden = !option?.dataset.comparePrice;
          }
          if (discountBadge) {
            discountBadge.textContent = option?.dataset.discountLabel || '';
            discountBadge.hidden = !option?.dataset.discountLabel;
          }
          if (cardImage && option?.dataset.imageSrc) {
            const nextImageSrc = option.dataset.imageSrc;
            const nextImageAlt = option.dataset.imageAlt || cardImage.alt;
            cardImage.dataset.pendingSrc = nextImageSrc;

            if (cardImage.src === new URL(nextImageSrc, window.location.href).href) {
              cardImage.alt = nextImageAlt;
            } else {
              const preloadedImage = new Image();
              preloadedImage.onload = () => {
                if (cardImage.dataset.pendingSrc !== nextImageSrc) return;
                cardImage.classList.add('is-changing');
                cardImage.src = nextImageSrc;
                cardImage.alt = nextImageAlt;
                window.requestAnimationFrame(() => {
                  window.requestAnimationFrame(() => cardImage.classList.remove('is-changing'));
                });
              };
              preloadedImage.src = nextImageSrc;
            }
          }
          if (quantityInput && option) {
            const minimum = Number(option.dataset.quantityMin || 1);
            const increment = Number(option.dataset.quantityStep || 1);
            quantityInput.min = String(minimum);
            quantityInput.step = String(increment);
            if (Number(quantityInput.value) < minimum) quantityInput.value = String(minimum);
          }
          pushEvent('change_product_configuration', {
            product: variantSelect.closest('form')?.getAttribute('data-money-counter-product') || undefined,
            variant_id: variantSelect.value
          });
          return;
        }

        const quantityInput = event.target.closest('[data-quantity-input]');
        if (quantityInput) {
          const minimum = Number(quantityInput.min || 1);
          const parsedValue = Number(quantityInput.value);
          if (!Number.isFinite(parsedValue) || parsedValue < minimum) quantityInput.value = String(minimum);
        }
      });

      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-compare-slot]');
        if (!select) return;
        const slot = Number(select.dataset.compareSlot);
        const isMobile = Boolean(select.closest('[data-mobile-compare-selectors]'));
        const previousId = compareSlots[slot];
        const duplicateIndex = compareSlots.findIndex((id, index) => index !== slot && id === select.value);
        if (duplicateIndex !== -1) {
          if (isMobile && duplicateIndex >= 2) {
            compareSlots[duplicateIndex] = previousId;
          } else {
            renderComparison();
            return;
          }
        }
        compareSlots[slot] = select.value;
        syncUrl();
        renderComparison();
        pushEvent('change_compare_model', { product: select.value, compare_slot: slot + 1 });
      });

      root.querySelector('[data-reset-compare]').addEventListener('click', () => {
        compareSlots = [...defaultSlots];
        syncUrl();
        renderComparison();
        pushEvent('reset_compare_models');
      });

      root.querySelectorAll('[data-money-counter-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.moneyCounterFilter;
          syncFilterUrl();
          renderProductFilter();
          pushEvent('filter_money_counter_models', { filter: activeFilter });
        });
      });

      root.querySelectorAll('[data-money-counter-scene]').forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.moneyCounterScene;
          syncFilterUrl();
          renderProductFilter();
          const catalog = root.querySelector('#money-counter-best-sellers');
          if (catalog) catalog.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });

      root.addEventListener('click', (event) => {
        const quantityButton = event.target.closest('[data-quantity-action]');
        if (quantityButton) {
          const control = quantityButton.closest('.money-counter-ads__quantity-control');
          const input = control?.querySelector('[data-quantity-input]');
          if (!input) return;
          if (quantityButton.dataset.quantityAction === 'plus') input.stepUp();
          else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const trigger = event.target.closest('[data-money-counter-event]');
        if (!trigger) return;
        const eventName = trigger.getAttribute('data-money-counter-event');
        if (eventName === 'add_to_cart') return;
        pushEvent(eventName, {
          product: trigger.getAttribute('data-money-counter-product') || undefined,
          use_case: trigger.getAttribute('data-money-counter-use-case') || undefined
        });
      });

      root.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-money-counter-event="add_to_cart"]');
        if (!form) return;
        pushEvent('add_to_cart', {
          product: form.getAttribute('data-money-counter-product') || undefined,
          variant_id: form.querySelector('[name="id"]')?.value || undefined,
          quantity: Number(form.elements.quantity?.value || 1)
        });
      });

      pushEvent('view_landing_page');
      renderComparison();
      renderProductFilter();
      initReviewCarousel();
      window.addEventListener('load', () => initReviewCarousel(), { once: true });
      const renderIcons = () => { if (window.lucide) window.lucide.createIcons(); };
      renderIcons();
      window.addEventListener('load', renderIcons, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-style-controls"] && !Shopify.designMode) return;
  try {
    
  function applyMunbynDealFloatingTools() {
    var launcher = document.querySelector('shulex-chatbot-lancher');
    if (!launcher || !launcher.shadowRoot) {
      return false;
    }

    var style = launcher.shadowRoot.querySelector('[data-munbyn-deal-mobile-tools]');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute('data-munbyn-deal-mobile-tools', '');
      style.textContent = '@media screen and (max-width: 749px) { #livechat_launcher_btn { right: 12px !important; bottom: 16px !important; width: 42px !important; height: 42px !important; } #livechat_launcher_btn > div { width: 42px !important; height: 42px !important; border-radius: 21px !important; } }';
      launcher.shadowRoot.appendChild(style);
    }

    return true;
  }

  function initialiseMunbynDealFloatingTools() {
    if (applyMunbynDealFloatingTools()) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function() {
      attempts += 1;
      if (applyMunbynDealFloatingTools() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  initialiseMunbynDealFloatingTools();
  document.addEventListener('shopify:section:load', initialiseMunbynDealFloatingTools);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-label-quantity-deals"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var option = event.target.closest('[data-label-option]');
    var toggle = event.target.closest('[data-label-deals-toggle]');

    if (option) {
      var card = option.closest('.munbyn-label-quantity-card');
      if (!card) {
        return;
      }

      var options = card.querySelectorAll('[data-label-option]');
      var variantInput = card.querySelector('[data-label-variant-input]');
      var buyButton = card.querySelector('[data-label-buy-button]');
      var learnLinks = card.querySelectorAll('[data-label-learn-link]');
      var ribbon = card.querySelector('[data-label-ribbon-percent]');
      var savings = card.querySelector('[data-label-savings]');
      var image = card.querySelector('.munbyn-label-quantity-card__image');

      options.forEach(function(item) {
        var isActive = item === option;
        item.classList.toggle('munbyn-label-quantity-card__option--active', isActive);
        item.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      if (variantInput) {
        variantInput.value = option.getAttribute('data-variant-id') || '';
      }

      if (buyButton) {
        var isAvailable = option.getAttribute('data-available') === 'true';
        buyButton.disabled = !isAvailable;
        buyButton.textContent = isAvailable ? card.getAttribute('data-buy-label') || 'Add To Cart' : 'Sold Out';
      }

      learnLinks.forEach(function(link) {
        link.href = option.getAttribute('data-product-url') || link.href;
      });

      if (ribbon) {
        var discount = option.getAttribute('data-discount') || '';
        if (discount) {
          ribbon.textContent = discount;
        }
      }

      if (savings) {
        var saveText = option.getAttribute('data-save') || '';
        savings.textContent = saveText;
        savings.hidden = !saveText;
      }

      if (image) {
        var imageUrl = option.getAttribute('data-image') || '';
        if (imageUrl) {
          image.src = imageUrl;
          image.removeAttribute('srcset');
        }
      }
    }

    if (toggle) {
      var section = toggle.closest('.munbyn-label-quantity-deals');
      var extras = section ? section.querySelectorAll('.munbyn-label-quantity-card--extra') : [];
      var label = toggle.querySelector('[data-label-deals-toggle-text]');
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      extras.forEach(function(card) {
        card.hidden = isExpanded;
      });

      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      if (label) {
        label.textContent = isExpanded ? 'Show more >' : 'Show less >';
      }
    }
  });

  function refreshLabelQuantityDeals() {
    document.querySelectorAll('[data-label-deals-section]').forEach(function(section) {
      var desktopCount = parseInt(section.getAttribute('data-desktop-visible-count'), 10) || 6;
      var mobileCount = parseInt(section.getAttribute('data-mobile-visible-count'), 10) || 4;
      var visibleCount = window.matchMedia('(max-width: 680px)').matches ? mobileCount : desktopCount;
      var cards = section.querySelectorAll('[data-label-card]');
      var toggleWrap = section.querySelector('[data-label-deals-toggle-wrap]');
      var toggle = section.querySelector('[data-label-deals-toggle]');
      var label = section.querySelector('[data-label-deals-toggle-text]');
      var isExpanded = toggle ? toggle.getAttribute('aria-expanded') === 'true' : false;
      var hasExtras = cards.length > visibleCount;

      cards.forEach(function(card, index) {
        var isExtra = index + 1 > visibleCount;
        card.classList.toggle('munbyn-label-quantity-card--extra', isExtra);
        card.hidden = isExtra && !isExpanded;
      });

      if (toggleWrap) {
        toggleWrap.hidden = !hasExtras;
      }

      if (toggle && !hasExtras) {
        toggle.setAttribute('aria-expanded', 'false');
      }

      if (label) {
        label.textContent = isExpanded && hasExtras ? 'Show less >' : 'Show more >';
      }
    });
  }

  refreshLabelQuantityDeals();
  document.addEventListener('DOMContentLoaded', refreshLabelQuantityDeals);
  window.addEventListener('resize', refreshLabelQuantityDeals);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-splash-categories"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function copyCategoryCode(button) {
      var code = button.getAttribute('data-category-copy-code');
      var label = button.querySelector('.munbyn-splash-category-product__copy-label');
      if (!code || !label) {
        return;
      }

      var originalText = label.textContent;
      var markCopied = function() {
        label.textContent = 'Copied';
        window.setTimeout(function() {
          label.textContent = originalText;
        }, 1400);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(markCopied).catch(function() {
          label.textContent = code;
        });
        return;
      }

      var input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        markCopied();
      } catch (error) {
        label.textContent = code;
      }
      document.body.removeChild(input);
    }

    function getVisibleLimit(section) {
      return Number(section.getAttribute('data-visible-count')) || 4;
    }

    function updateSection(section, target, isExpanded) {
      var tabs = section.querySelectorAll('[data-category-tab]');
      var cards = section.querySelectorAll('[data-category-card]');
      var button = section.querySelector('[data-category-show-more]');
      var label = section.querySelector('[data-category-show-more-text]');
      var wrap = section.querySelector('[data-category-toggle-wrap]');
      var visibleLimit = getVisibleLimit(section);
      var visibleCount = 0;
      var extraCount = 0;

      tabs.forEach(function(item) {
        var isActive = item.getAttribute('data-category-tab') === target;
        item.classList.toggle('munbyn-splash-categories__tab--active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      cards.forEach(function(card) {
        var isTarget = card.getAttribute('data-category-card') === target;
        var index = Number(card.getAttribute('data-category-index')) || 0;
        if (isTarget) {
          visibleCount += 1;
        }
        if (isTarget && index > visibleLimit) {
          extraCount += 1;
        }
        card.hidden = !isTarget || (!isExpanded && index > visibleLimit);
      });

      if (button) {
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }

      if (label) {
        label.textContent = isExpanded ? 'Show less >' : 'Show more >';
      }

      if (wrap) {
        wrap.hidden = visibleCount <= visibleLimit || extraCount === 0;
      }

      var grid = section.querySelector('.munbyn-splash-categories__grid');
      if (grid) {
        grid.setAttribute('data-visible-total', String(Math.min(visibleCount, isExpanded ? visibleCount : visibleLimit)));
      }
    }

    function getActiveCategory(section) {
      var activeTab = section.querySelector('.munbyn-splash-categories__tab--active');
      return activeTab ? activeTab.getAttribute('data-category-tab') : 'printers';
    }

    function updateAllSections() {
      document.querySelectorAll('.munbyn-splash-categories').forEach(function(section) {
        var button = section.querySelector('[data-category-show-more]');
        var isExpanded = button ? button.getAttribute('aria-expanded') === 'true' : false;
        updateSection(section, getActiveCategory(section), isExpanded);
      });
    }

    var resizeTimer;
    document.addEventListener('click', function(event) {
      var copyButton = event.target.closest('[data-category-copy-code]');
      if (copyButton) {
        copyCategoryCode(copyButton);
        return;
      }

      var tab = event.target.closest('[data-category-tab]');
      var toggle = event.target.closest('[data-category-show-more]');
      if (!tab && !toggle) {
        return;
      }

      var section = (tab || toggle).closest('.munbyn-splash-categories');
      if (!section) {
        return;
      }

      var button = section.querySelector('[data-category-show-more]');
      var target = tab ? tab.getAttribute('data-category-tab') : getActiveCategory(section);
      var isExpanded = toggle && button ? button.getAttribute('aria-expanded') !== 'true' : false;

      updateSection(section, target, isExpanded);
    });

    updateAllSections();
    document.addEventListener('DOMContentLoaded', updateAllSections);
    document.addEventListener('shopify:section:load', updateAllSections);
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateAllSections, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-splash-feature"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var tab = event.target.closest('[data-feature-tab]');
    if (tab) {
      var feature = tab.closest('.munbyn-splash-feature');
      if (!feature) {
        return;
      }

      var target = tab.getAttribute('data-feature-tab');
      var tabs = feature.querySelectorAll('[data-feature-tab]');
      var panels = feature.querySelectorAll('[data-feature-panel]');

      tabs.forEach(function(item) {
        var isActive = item === tab;
        item.classList.toggle('munbyn-splash-feature__tab--active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function(panel) {
        var isTarget = panel.getAttribute('data-feature-panel') === target;
        panel.hidden = !isTarget;
        panel.classList.toggle('munbyn-splash-feature__card--hidden', !isTarget);
      });
      return;
    }

    var trigger = event.target.closest('[data-copy-code]');
    if (!trigger) {
      return;
    }

    var code = trigger.getAttribute('data-copy-code');
    var label = trigger.querySelector('.munbyn-splash-feature__copy-label');
    if (!code || !label) {
      return;
    }

    var originalText = label.textContent;
    var markCopied = function() {
      label.textContent = 'Copied';
      trigger.classList.add('is-copied');
      window.setTimeout(function() {
        label.textContent = originalText;
        trigger.classList.remove('is-copied');
      }, 1600);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(markCopied).catch(function() {
        label.textContent = code;
      });
      return;
    }

    var input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      markCopied();
    } catch (error) {
      label.textContent = code;
    }
    document.body.removeChild(input);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-splash-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-show-more-toggle]');
    if (!toggle) {
      return;
    }

    var section = toggle.closest('.munbyn-splash-products');
    if (!section) {
      return;
    }

    var cards = section.querySelectorAll('.munbyn-splash-deal-card--extra');
    var label = toggle.querySelector('[data-show-more-text]');
    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    cards.forEach(function(card) {
      card.hidden = isExpanded;
    });

    toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    if (label) {
      label.textContent = isExpanded ? 'Show more >' : 'Show less >';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-splash-stock-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-stock-grid-toggle]');
    var copyButton = event.target.closest('[data-stock-code-copy]');

    if (toggle) {
      var section = toggle.closest('.munbyn-splash-stock-grid');
      var extras = section ? section.querySelectorAll('.munbyn-splash-stock-card--extra') : [];
      var label = toggle.querySelector('[data-stock-grid-toggle-text]');
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      extras.forEach(function(card) {
        card.hidden = isExpanded;
      });

      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      if (label) {
        label.textContent = isExpanded ? 'Show more >' : 'Show less >';
      }
    }

    if (copyButton) {
      var code = copyButton.getAttribute('data-stock-code-copy');
      if (!code) {
        return;
      }

      var originalText = copyButton.textContent;
      var setCopied = function() {
        copyButton.textContent = 'Copied';
        window.setTimeout(function() {
          copyButton.textContent = originalText;
        }, 1600);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(setCopied);
      } else {
        var field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.left = '-9999px';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        document.body.removeChild(field);
        setCopied();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pda-comparison"] && !Shopify.designMode) return;
  try {
    
  (()=>{const groups=[{id:'quick',title:'Quick Look',rows:[['recommendedUse','Recommended use'],['scanClass','Scan distance'],['engine','Scanner engine'],['formFactorSummary','Form factor'],['os','Operating system'],['connectivity','Wireless & cellular'],['battery','Battery & charging'],['ruggedness','Ruggedness']]},{id:'performance',title:'Performance',rows:[['cpu','Processor'],['memory','Memory & storage']]},{id:'physical',title:'Physical Characteristics',rows:[['dimensions','Dimensions'],['weight','Weight'],['screenSize','Screen size'],['display','Display']]},{id:'camera',title:'Camera & Ports',rows:[['camera','Camera'],['ports','Ports']]},{id:'certification',title:'Certification',rows:[['certification','Certification']]}];
  const esc=v=>String(v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  document.querySelectorAll('[data-pda-compare]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const data=JSON.parse(section.querySelector('[data-pda-data]').textContent);const root=section.querySelector('[data-comparison-root]');const differences=section.querySelector('[data-differences]');const toggleAll=section.querySelector('[data-toggle-all]');let selected=['ipda101','as01','mc005'];let variants={ipda101:'grip',as01:'grip',mc005:'grip'};let expanded=new Set(['quick']);let scrollLeft=0;let compact;
  const product=id=>data.products.find(item=>item.id===id);const variant=item=>item.variants[variants[item.id]]||Object.values(item.variants)[0];const value=(item,key)=>{if(item.uncertain.includes(key)&&!data.showUncertain)return'-';const current=variant(item);if(key==='formFactorSummary')return`${item.specs.formFactor}; ${current.label}`;if(key==='ruggedness')return`${item.specs.drop} drop; ${item.specs.ingress}`;return current[key]??item.specs[key]??'Not listed'};
  const selectMarkup=(item,index)=>`<label><span>Model</span><select data-product-index="${index}" aria-label="Model">${data.products.map(option=>`<option value="${option.id}" ${option.id===item.id?'selected':''} ${selected.includes(option.id)&&option.id!==item.id?'disabled':''}>${esc(option.displayName)}</option>`).join('')}</select></label>`;
  const variantsMarkup=item=>{const entries=Object.entries(item.variants);if(entries.length===1)return`<span class="pda-single-variant">${esc(entries[0][1].label)}</span>`;return`<div class="pda-segmented" aria-label="${esc(item.displayName)} grip configuration">${entries.map(([key,itemVariant])=>`<button type="button" data-variant-product="${item.id}" data-variant="${key}" class="${variant(item)===itemVariant?'is-active':''}" aria-pressed="${variant(item)===itemVariant}">${esc(itemVariant.label)}</button>`).join('')}</div>`};
  const head=(item,index)=>{const current=variant(item);const badge=data.showTierBadges?`<span class="pda-badge">${esc(item.badge)}</span>`:'';return`<div class="pda-product-head">${selectMarkup(item,index)}<div class="pda-product-visual"><img src="${esc(current.image)}" alt="${esc(current.model)} Android barcode scanner" loading="${index===0?'eager':'lazy'}" width="420" height="420"></div>${badge}<div class="pda-product-summary"><h2>${esc(current.model)}</h2><p class="pda-price">${esc(current.price)}</p></div>${variantsMarkup(item)}<a class="pda-product-link" href="${esc(current.url)}">View product <span aria-hidden="true">&#8250;</span></a></div>`};
  const render=()=>{const oldScroller=root.querySelector('.pda-scroller');if(oldScroller)scrollLeft=oldScroller.scrollLeft;const products=selected.map(product);const activeGroups=groups.map(group=>({...group,rows:group.rows.filter(([key])=>data.fields[key]!==false)})).filter(group=>group.rows.length);const groupMarkup=activeGroups.map(group=>{const rows=group.rows.map(([key,label])=>{const values=products.map(item=>value(item,key));return{key,label,values,diff:new Set(values).size>1}}).filter(row=>!row.values.every(item=>item==='-')&&(!differences.checked||row.diff));if(differences.checked&&!rows.length)return'';const open=expanded.has(group.id);return`<section class="pda-group"><button class="pda-group__trigger" type="button" data-group="${group.id}" aria-expanded="${open}"><span>${esc(group.title)}</span><span class="pda-chevron" aria-hidden="true"></span></button>${open?`<div>${rows.map(row=>`<div class="pda-spec-row ${differences.checked&&row.diff?'is-different':''}"><div class="pda-row-label">${esc(row.label)}</div>${row.values.map(item=>`<div class="pda-spec-value">${esc(item)}</div>`).join('')}</div>`).join('')}</div>`:''}</section>`}).join('');root.innerHTML=`<div class="pda-scroller" tabindex="0" aria-label="Product comparison table"><div class="pda-table"><div class="pda-product-row"><div class="pda-row-label pda-product-label"><span>Compare</span><small>3 products</small></div>${products.map(head).join('')}</div>${groupMarkup}</div></div>`;const scroller=root.querySelector('.pda-scroller');scroller.scrollLeft=scrollLeft;bind();syncSticky();const allOpen=activeGroups.every(group=>expanded.has(group.id));toggleAll.firstChild.textContent=allOpen?'Collapse all':'Expand all';toggleAll.classList.toggle('is-open',allOpen)};
  const bind=()=>{root.querySelectorAll('[data-product-index]').forEach(select=>select.addEventListener('change',event=>{const index=Number(event.currentTarget.dataset.productIndex);selected[index]=event.currentTarget.value;const item=product(selected[index]);if(Object.keys(item.variants).length>1&&!variants[item.id])variants[item.id]='grip';render()}));root.querySelectorAll('[data-variant-product]').forEach(button=>button.addEventListener('click',event=>{variants[event.currentTarget.dataset.variantProduct]=event.currentTarget.dataset.variant;render()}));root.querySelectorAll('[data-group]').forEach(button=>button.addEventListener('click',event=>{const id=event.currentTarget.dataset.group;expanded.has(id)?expanded.delete(id):expanded.add(id);render()}));root.querySelector('.pda-scroller').addEventListener('scroll',syncSticky,{passive:true})};
  const headerOffset=()=>Math.max(0,...[...document.querySelectorAll('.header-section,header')].map(element=>{const rect=element.getBoundingClientRect();const position=getComputedStyle(element).position;return(position==='fixed'||position==='sticky')&&rect.top<=1&&rect.bottom>0?rect.bottom:0}));
  const syncSticky=()=>{const scroller=root.querySelector('.pda-scroller');const table=root.querySelector('.pda-table');const productRow=root.querySelector('.pda-product-row');const main=section.querySelector('.pda-compare__main');const business=section.querySelector('.pda-compare__business');const interactionVisible=matchMedia('(max-width:720px)').matches&&main.getBoundingClientRect().top<innerHeight&&business.getBoundingClientRect().bottom>0;document.body.classList.toggle('pda-compare-interaction-active',interactionVisible);if(!scroller||!table||!productRow)return;const top=Math.ceil(headerOffset());const visible=productRow.getBoundingClientRect().bottom<=top+64&&table.getBoundingClientRect().bottom>top+64;if(!visible){compact?.remove();compact=null;return}if(!compact){compact=document.createElement('div');compact.className='pda-compact';document.body.appendChild(compact)}const products=selected.map(product);compact.style.setProperty('--pda-compact-top',`${top}px`);compact.style.left=`${Math.round(scroller.getBoundingClientRect().left)}px`;compact.style.width=`${Math.round(scroller.clientWidth)}px`;compact.innerHTML=`<div class="pda-compact__row" style="width:${table.scrollWidth}px;transform:translateX(-${Math.round(scroller.scrollLeft)}px)"><div class="pda-compact__label">Models</div>${products.map(item=>{const current=variant(item);return`<div class="pda-compact__product"><span>${esc(current.model)}</span><strong>${esc(current.price)}</strong></div>`}).join('')}</div>`};
  section.querySelector('.pda-switch').addEventListener('click',event=>{if(event.target===differences)return;event.preventDefault();differences.checked=!differences.checked;render()});differences.addEventListener('change',render);toggleAll.addEventListener('click',()=>{const active=groups.filter(group=>group.rows.some(([key])=>data.fields[key]!==false));const allOpen=active.every(group=>expanded.has(group.id));expanded=allOpen?new Set():new Set(active.map(group=>group.id));render()});window.addEventListener('scroll',syncSticky,{passive:true});window.addEventListener('resize',syncSticky);render()})})();

  } catch(e) { console.error(e); }
})();
})();
